import React from "react"
import { SidebarCard } from "./SidebarCard"

/**
 * The Appointments page's right rail, as one named export for the host to drop into
 * `PageLayout variant="sidebar"`'s `sidebar` slot.
 *
 * A wrapper over `SidebarCard` rather than exporting that component directly, because the rail is a
 * page slot and the card is one thing that happens to be in it today. The design shows only the
 * contact tile in all ten frames; when a second block joins it, it joins here and the host does not
 * change. Mirrors `ConsumerCarrotPlanSidebar`, the same shape on the consumer home page.
 */
export function AppointmentsSidebar(): JSX.Element {
  return <SidebarCard />
}
